

import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({})
export default class H3 extends Vue {
  @Prop({ default: 'default' }) variant: string
}

